import React from 'react';

import Store from './store';
import Header from './components/Header';
import ImportSchedule from './components/ImportSchedule';
import Schedule from './components/Schedule';
import PrintView from './components/PrintView';

export default class CoachingSchedule extends React.Component {
    render() {
        return (
            <Store { ...this.props } render={ (props) => (
                <div>
                    <div className="print-hide">
                        <Header { ...props } />
                        {
                            props.loaded ? (
                                <div>
                                    <ImportSchedule { ...props } />
                                    <Schedule { ...props } />
                                </div>
                            ) : null
                        }
                    </div>
                    <div className="print-show">
                        <PrintView { ...props } />
                    </div>
                </div>
            ) } />
        );
    }
}
